import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
import { mapGetters } from 'vuex';

var bgColor = [
    '#539158',
    '#7D9D4E',
    '#A6A843',
    '#D0B438',
    '#F8AB35',
    '#F5963E',
    '#F18146',
    '#EE6C4D'
];

export default {
    name: 'dspScore',
    inject: ['$eventBus'],
    data() {
        return {
            tip:'In 2018-2019, California tested students using the California Assessment of Student Performance and Progress (CAASPP), administered through the online Smarter Balanced Summative Assessments. These are comprehensive, end-of-year assessments of grade-level learning that measure progress toward college and career readiness. Each test, English language arts/literacy (ELA) and mathematics is comprised of two parts: (1) a computer adaptive test and (2) a performance task; administered within a 12-week window beginning at 66 percent of the instructional year for grades three through eight, or within in a 7-week window beginning at 80 percent of the instructional year for grade eleven. The summative assessments are aligned with the Common Core State Standards (CCSS) for ELA and mathematics. The tests capitalize on the strengths of computer adaptive testing-efficient and precise measurement across the full range of achievement and timely turnaround of results.',
            tip1: 'In 2015-2016 California used the California Standards Tests (CSTs) to test students in science in grades 5, 8 and 10. The CSTs are standards-based tests, which means they measure how well students are mastering specific skills defined for each grade by the state of California. The goal is for all students to score at or above proficient on the tests.',
            chartData: null,
            typeIndex: -1,
            gradeIndex: -1,
            description: ''
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp'])
    },
    components: {
        mvtChart
    },
    methods: {
        updateIndex(i, j){
            if(i !== this.typeIndex || j !== this.gradeIndex){
                this.typeIndex = i;
                this.gradeIndex = j;
                this.updateChart();
            }
        },
        updateChart(){
            var score = this.dsp && this.dsp.tests && this.dsp.tests[this.typeIndex].score;
            if(!score || !score.details || !score.details.length){
                this.chartData = null;
                return;
            }
            var item = score.details[this.gradeIndex];
            if (item) {
                const labels = [];
                const subjects = [];
                const datasets = [];
                if(item.subjects && item.subjects.length){
                    item.subjects.forEach(e => {
                        var subjectName = e.name;
                        if(subjects.indexOf(subjectName) === -1){
                            subjects.push(subjectName);
                        }
                        for(var key in e.yearScore){
                            if(labels.indexOf(key) === -1){
                                labels.push(key);

                            }
                        }
                    });
                    item.subjects.forEach(function(e){
                        var subjectName = e.name;
                        for(var key in e.yearScore){
                            var value = e.yearScore[key].replace('%', '');
                            var dataset = datasets.find(s => s.label === subjectName);
                            if(dataset){
                                dataset.data[labels.indexOf(key)] = value;
                            } else {
                                var data = new Array(labels.length);
                                data[labels.indexOf(key)] = value;
                                var color;
                                if(/math/i.test(subjectName)){
                                    color = '#EE6C4D';
                                }else if(/english/i.test(subjectName)){
                                    color = '#FBC02D';
                                } else if(/science/i.test(subjectName)){
                                    color = '#1F8265';
                                } else {
                                    color = bgColor[subjects.findIndex(x=> x === subjectName)];
                                }
                                datasets.push({
                                    label: subjectName,
                                    data: data,
                                    backgroundColor: color,
                                    stack: subjectName
                                });
                            }
                        }
                    });
                    const data = {
                        labels: labels,
                        datasets: datasets
                    };
                    this.chartData = {
                        type: 'bar',
                        data: data,
                        options: {
                            legend: {
                                display: true,
                                onClick: (e) => e.stopPropagation()
                            },
                            plugins: {
                                title: {
                                    display: true,
                                    text: 'Chart.js Bar Chart - Stacked'
                                }
                            },
                            responsive: true,
                            interaction: {
                                intersect: false
                            },
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true,
                                        stepValue: 20,
                                        min: 0,
                                        max: 100,
                                        stepSize: 20,
                                        callback: function(value, index, values) {
                                            return value + '%';
                                        }
                                    },
                                    stacked: true
                                }]
                            }
                        }
                    };
                }

            }
        }
    },
    mounted() {
        this.updateIndex(0, 0);
    }
};

